import React from "react";
import MediaKitSection from "../../components/Media/MediaKit.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
// import PartnerWithAptechSection from "../components/PartnerWithAptech/PartnerWithAptech.tsx";
const MediaKit = () => {
  return (
    <>
      <MetaComponent
        title="Aptech Media Kit – Information about Vocational Training & Skill Development."
        desc="Explore Aptech’s Media Kit for business logos, achievements, press releases, and details on vocational training and skill development programs."
        keywords="vocational training, skill development, Aptech Media Kit."
      />
      <MediaKitSection />
    </>
  );
};

export default MediaKit;
